import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaSearch,
  FaPhoneAlt,
  FaChevronDown,
  FaChevronUp,
  FaBars,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import OrderWithCartsPopup from "../OrderPopUp/OrderWithCartsPopup";
// import Logo from "../Assets/logo-02.jpeg";
import Logo from "../Assets/fabhub-logo-nav.png";
import { ShopContext } from "../../Context/ShopContext";
import { WishlistContext } from "../../Context/WishlistContext";
import { MdOutlineShoppingCart, MdClose, MdDelete } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { LuUserRound } from "react-icons/lu";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";
import { currency, backend_url } from "../../App";
import Dropdown from "../Navbar/DropDown";
import PriceRangeDropdown from "../Navbar/PriceRangeDropdown";
import { toast } from "react-toastify";

import useSiteMenu from "../../utils/useSiteMenu";
import { parseCartKey, findColorInProduct } from "../../utils/cartKey";

// Quick-tap shortcuts shown under the mobile search bar — faster than typing
// or digging through the category dropdown for the things people look for most.
const POPULAR_SEARCHES = [
  { label: "Georgette", path: "/collections/georgette-fabric" },
  { label: "Pure Silk Saree", path: "/collections/pure-silk-sarees" },
  { label: "Plain Cotton", path: "/collections/plain-cotton-fabric" },
  { label: "Customized Fabrics", path: "/collections/customized-fabrics" },
  { label: "Vintage Collection", path: "/collections/vintage-collection" },
];

const Search = ({ setSearchResults }) => {
  const {
    products,
    addToCart,
    cartItems,
    removeFromCart,
    getTotalCartItems,
    deleteFromCart,
    getTotalCartAmount,
  } = useContext(ShopContext);

  const { wishlist, setWishlistOpen, toggleWishlist } = useContext(WishlistContext);
  // Top menu — editable from the admin panel; same rendering as before
  const menuItems = useSiteMenu();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const location = useLocation();
  const [orderPopupOpen, setOrderPopupOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const cartRef = useRef(null);
  const forceUpdate = useState()[1];
  const isAuthorize = !!localStorage.getItem("auth-token");
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [openSubDropdowns, setOpenSubDropdowns] = useState({});
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    fetch(`${backend_url}/api/settings`)
      .then((r) => r.json())
      .then((d) => {
        if (d.success && d.settings?.announcementEnabled && d.settings?.announcementText?.trim()) {
          setAnnouncement(d.settings.announcementText.trim());
        }
      })
      .catch(() => {});
  }, []);

  const toggleSubDropdown = (parentIndex, subIndex) => {
    setOpenSubDropdowns((prev) => ({
      ...prev,
      [parentIndex]: {
        ...prev[parentIndex],
        [subIndex]: !prev[parentIndex]?.[subIndex],
      },
    }));
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
  const toggleMobileDropdown = (index) => {
    setOpenMobileDropdown((prev) => (prev === index ? null : index));
  };

  const handleItemClick = (item) => {
    if (!item.dropdown && !item.subDropdown) {
      handleMouseLeave();
    }
  };

  const handleMouseEnter = (index) => setOpenMenu(index);
  const handleMouseLeave = () => setOpenMenu(null);

  const applyPriceRange = (min, max) => {
    const params = new URLSearchParams();
    if (min !== "" && min != null) params.set("minPrice", min);
    if (max !== "" && max != null) params.set("maxPrice", max);
    navigate(`/collections/all?${params.toString()}`);
    setOpenMenu(null);
    setOpenMobileDropdown(null);
    setIsMobileMenuOpen(false);
  };
  const [showPopup, setShowPopup] = useState(false);

  const handlePopupNow = () => {
    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      setOpen(false);
      navigate("/login", { state: { from: location.pathname + location.search } });
      return;
    }
    setShowPopup(true);
  };

  const closePopup = () => setShowPopup(false);

  // Handle search logic
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() !== "") {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(filtered);
      setSearchResults(filtered);
    } else {
      setFilteredProducts([]);
      setSearchResults([]);
    }
  };

  return (
    <>
      <div>
        {/* Running Announcement Section (managed from Admin → Settings) */}
        {announcement && (
          <div
            className="w-full py-2 font-semibold text-xs sm:text-sm flex items-center overflow-hidden"
            style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-primary-500), var(--brand-primary-600))" }}
          >
            <div className="whitespace-nowrap overflow-hidden flex-grow">
              <p className="inline-block animate-marquee text-white tracking-wide uppercase">
                {announcement}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{announcement}
              </p>
            </div>
          </div>
        )}

        <nav className="w-full bg-white relative z-50 px-4 md:px-8 py-2 border-b border-[var(--brand-primary-100)] shadow-[0_2px_16px_rgba(124,58,237,0.07)]">
          {/* Top Row - Desktop */}
          <div className="hidden md:flex items-center justify-between gap-6">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/home">
                <img crossOrigin="anonymous" src={Logo} alt="Logo" className="w-[110px]" />
              </Link>
            </div>

            {/* Search */}
            <div className="flex-1 flex justify-center">
              <div className="relative flex items-center rounded-full w-full max-w-2xl shadow-sm focus-within:shadow-[0_0_0_2px_var(--brand-primary-500)] transition-all" style={{ border: "1.5px solid var(--brand-primary-300)" }}>
                <FaSearch className="text-[var(--brand-primary-400)] cursor-pointer ml-4 mr-3 flex-shrink-0" />
                <input type="text" placeholder="Search fabrics, sarees & more…" onChange={handleSearch}
                  className="text-sm w-full pr-4 py-2.5 outline-none text-gray-700 placeholder-gray-400 bg-transparent rounded-full" />
              </div>
            </div>

            {/* Icons */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <a href="tel:+919789389489"
                className="w-9 h-9 rounded-full flex items-center justify-center bg-[var(--brand-primary-50)] hover:bg-[var(--brand-primary-600)] group transition-all duration-200 border border-[var(--brand-primary-100)]">
                <FaPhoneAlt className="text-sm text-[var(--brand-primary-600)] group-hover:text-white transition-colors" />
              </a>
              <Link to="/user-profile"
                className="w-9 h-9 rounded-full flex items-center justify-center bg-[var(--brand-primary-50)] hover:bg-[var(--brand-primary-600)] group transition-all duration-200 border border-[var(--brand-primary-100)] relative">
                <LuUserRound className="text-lg text-[var(--brand-primary-600)] group-hover:text-white transition-colors" />
                <span className="absolute -top-1 -right-1 text-sm leading-none">⚡</span>
              </Link>

              {/* Wishlist heart */}
              <button
                onClick={() => setWishlistOpen(true)}
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 border relative"
                style={{
                  background: wishlist.length > 0 ? "linear-gradient(135deg,var(--brand-primary-600),var(--brand-primary-500))" : "var(--brand-primary-50)",
                  borderColor: wishlist.length > 0 ? "transparent" : "var(--brand-primary-100)",
                }}
                title="My Wishlist"
              >
                {wishlist.length > 0
                  ? <FaHeart size={14} color="white" />
                  : <FiHeart size={14} style={{ color: "var(--brand-primary-600)" }} />
                }
                {wishlist.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-pink-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {wishlist.length}
                  </span>
                )}
              </button>

              <button onClick={() => setOpen(true)}
                className="w-9 h-9 rounded-full flex items-center justify-center bg-[var(--brand-primary-50)] hover:bg-[var(--brand-primary-600)] group transition-all duration-200 border border-[var(--brand-primary-100)] relative">
                <MdOutlineShoppingCart className="text-xl text-[var(--brand-primary-600)] group-hover:text-white transition-colors" />
                {getTotalCartItems() > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-green-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {getTotalCartItems()}
                  </span>
                )}
              </button>
            </div>
          </div>

          {/* Top Row - Mobile — Wishlist/Cart/Account are dropped here since
              the bottom tab bar already covers them; Phone and Menu aren't
              available anywhere else on mobile, so they stay. */}
          <div className="flex md:hidden items-center justify-between py-1">
            <Link to="/home"><img crossOrigin="anonymous" src={Logo} alt="Logo" className="w-[100px]" /></Link>
            <div className="flex items-center gap-2">
              <a href="tel:+919789389489"
                className="w-8 h-8 rounded-full flex items-center justify-center bg-[var(--brand-primary-50)] border border-[var(--brand-primary-100)]">
                <FaPhoneAlt className="text-xs text-[var(--brand-primary-600)]" />
              </a>
              <button onClick={toggleMobileMenu}
                className="w-8 h-8 rounded-full flex items-center justify-center bg-[var(--brand-primary-50)] border border-[var(--brand-primary-100)]">
                <FaBars className="text-base text-[var(--brand-primary-600)]" />
              </button>
            </div>
          </div>

          {/* Search - Mobile */}
          <div className="mt-2 md:hidden">
            <div className="relative flex items-center rounded-full w-full" style={{ border: "1.5px solid var(--brand-primary-300)" }}>
              <FaSearch className="text-[var(--brand-primary-400)] ml-3 mr-2 text-sm flex-shrink-0" />
              <input type="text" placeholder="Search…" onChange={handleSearch}
                className="text-sm w-full pr-3 py-2 outline-none text-gray-700 bg-transparent rounded-full" />
            </div>

            {/* Popular searches — quick-tap chips instead of typing */}
            <div className="flex items-center gap-2 mt-2.5 overflow-x-auto scrollbar-hide pb-0.5">
              <span className="text-[11px] font-semibold text-gray-400 flex-shrink-0">Popular:</span>
              {POPULAR_SEARCHES.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => window.scrollTo(0, 0)}
                  className="flex-shrink-0 text-xs font-medium text-[var(--brand-primary-700)] bg-[var(--brand-primary-50)] border border-[var(--brand-primary-100)] px-3 py-1.5 rounded-full whitespace-nowrap hover:bg-[var(--brand-primary-100)] transition-colors"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Desktop nav menu */}
          <div className="hidden md:flex justify-center mt-2.5 mb-1 border-t border-[var(--brand-primary-50)] pt-2.5">
            <ul className="flex gap-1">
              {menuItems.map((item, index) => (
                <li key={index} className="relative group overflow-visible"
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}>
                  {item.path ? (
                    <Link to={item.path}
                      className="relative flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-semibold text-gray-600
                                 hover:text-[var(--brand-primary-700)] hover:bg-[var(--brand-primary-50)] transition-all duration-200 tracking-wide">
                      {item.label}
                      {/* Active underline dot */}
                      <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[var(--brand-primary-500)] opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </Link>
                  ) : (
                    // Dropdown-only item: no navigation, click also toggles (for touch devices)
                    <button
                      type="button"
                      onClick={() => setOpenMenu(openMenu === index ? null : index)}
                      className="relative flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-semibold text-gray-600
                                 hover:text-[var(--brand-primary-700)] hover:bg-[var(--brand-primary-50)] transition-all duration-200 tracking-wide">
                      {item.label}
                      {(item.dropdown || item.priceFilter) && (
                        <IoIosArrowDown className={`text-xs transition-transform duration-200 ${openMenu === index ? "rotate-180 text-[var(--brand-primary-600)]" : ""}`} />
                      )}
                      <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[var(--brand-primary-500)] opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </button>
                  )}
                  {item.dropdown && openMenu === index && <Dropdown items={item.dropdown} />}
                  {item.priceFilter && openMenu === index && (
                    <PriceRangeDropdown
                      onApply={applyPriceRange}
                      className="absolute top-full left-0 bg-white shadow-xl border border-[var(--brand-primary-100)] rounded-xl py-2 w-64 z-[200]"
                    />
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>

        {/* Off-Canvas Mobile Menu */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-40"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
        <div
          className={`fixed top-0 right-0 h-full w-72 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
            isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {/* Sidebar header */}
          <div className="flex justify-between items-center px-5 py-4"
               style={{ background: "linear-gradient(135deg, var(--brand-primary-900), var(--brand-secondary-600))" }}>
            <div>
              <p className="text-white font-bold text-base">AavryaA FabHub</p>
              <p className="text-[var(--brand-primary-200)] text-xs">Premium Indian Fabrics</p>
            </div>
            <button onClick={() => setIsMobileMenuOpen(false)}
              className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition">
              <MdClose className="text-white text-lg" />
            </button>
          </div>

          {/* Menu Items */}
          <ul className="flex flex-col gap-2 px-4 py-3 pb-24 text-gray-800 text-sm overflow-y-auto h-full">
            {menuItems.map((item, index) => (
              <li key={index}>
                <div
                  className="flex justify-between items-center cursor-pointer py-2"
                  onClick={() =>
                    item.dropdown || item.priceFilter
                      ? toggleMobileDropdown(index)
                      : setIsMobileMenuOpen(false)
                  }
                >
                  {item.priceFilter ? (
                    <span className="block hover:text-[var(--brand-primary-600)]">{item.label}</span>
                  ) : (
                    <Link
                      to={item.path || "#"}
                      className="block hover:text-[var(--brand-primary-600)]"
                      onClick={() => !item.dropdown && setIsMobileMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  )}
                  {(item.dropdown || item.priceFilter) && (
                    <span>
                      {openMobileDropdown === index ? (
                        <FaChevronUp className="text-xs" />
                      ) : (
                        <FaChevronDown className="text-xs" />
                      )}
                    </span>
                  )}
                </div>
                {item.priceFilter && openMobileDropdown === index && (
                  <PriceRangeDropdown onApply={applyPriceRange} className="pl-4 border-l border-[var(--brand-primary-300)] ml-2 py-2" />
                )}
                {item.dropdown && openMobileDropdown === index && (
                  <ul className="pl-4 border-l border-[var(--brand-primary-300)] ml-2">
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex} className="py-1">
                        {subItem.subDropdown ? (
                          // This is a dropdown toggle
                          <div
                            className="flex justify-between items-center cursor-pointer pl-2 pr-2"
                            onClick={() => toggleSubDropdown(index, subIndex)}
                          >
                            <span className="text-sm text-gray-800 hover:text-[var(--brand-primary-600)]">
                              {subItem.label}
                            </span>
                            {openSubDropdowns?.[index]?.[subIndex] ? (
                              <FaChevronUp className="text-xs" />
                            ) : (
                              <FaChevronDown className="text-xs" />
                            )}
                          </div>
                        ) : (
                          // This is a normal link
                          <Link
                            to={subItem.path || "#"}
                            className="block hover:text-[var(--brand-primary-600)] pl-2 pr-2"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {subItem.label}
                          </Link>
                        )}

                        {/* Handle subDropdown */}
                        {subItem.subDropdown &&
                          openSubDropdowns?.[index]?.[subIndex] && (
                            <ul className="ml-4 border-l border-[var(--brand-primary-200)] mt-1">
                              {subItem.subDropdown.map(
                                (nested, nestedIndex) => (
                                  <li key={nestedIndex} className="py-1">
                                    <Link
                                      to={nested.path}
                                      className="block text-sm text-gray-600 hover:text-[var(--brand-primary-600)]"
                                      onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                      {nested.label}
                                    </Link>
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Overlay & Cart Section */}
        {open && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[60] transition-opacity duration-300"
            onClick={() => setOpen(false)}
          >
            <div
              ref={cartRef}
              onClick={(e) => e.stopPropagation()}
              className="cart-container fixed top-0 right-0 w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-[28%] z-[70] bg-white h-screen border-l shadow-2xl flex flex-col"
            >
              {/* Header */}
              <div className="flex justify-between items-center px-5 py-4"
                   style={{ background: "linear-gradient(135deg, var(--brand-primary-900), var(--brand-secondary-600))" }}>
                <div>
                  <p className="text-white font-bold text-lg">Your Cart</p>
                  <p className="text-[var(--brand-primary-200)] text-xs">{getTotalCartItems()} item{getTotalCartItems() !== 1 ? "s" : ""}</p>
                </div>
                <button onClick={() => setOpen(false)}
                  className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition">
                  <MdClose className="text-white text-lg" />
                </button>
              </div>

              {/* Product Section (scrollable) */}
              <div className="flex-1 overflow-y-auto">
                {Object.keys(cartItems).length > 0 ? (
                  Object.keys(cartItems)
                    .filter((id) => cartItems[id] > 0)
                    .map((id) => {
                      const { productId, colorId } = parseCartKey(id);
                      const product = products.find((p) => p.id === productId);
                      const color = findColorInProduct(product, colorId);
                      return product ? (
                        <div
                          key={id}
                          className="justify-center items-center p-4 border-b flex gap-4"
                        >
                          {/* Product Image */}
                          <img
                            crossOrigin="anonymous"
                            className="w-24 h-24 object-cover rounded-lg border"
                            src={color?.images?.[0] || product.images[0]}
                            alt={product.name}
                          />

                          {/* Product Details */}
                          <div className="flex flex-col flex-1 justify-between">
                            <p className="text-lg font-semibold break-words">
                              {product.name}
                            </p>
                            {color && (
                              <span className="inline-flex items-center gap-1.5 text-xs text-gray-500 mt-0.5">
                                <span
                                  className="w-3 h-3 rounded-full flex-shrink-0"
                                  style={{ background: color.hex, border: "1px solid rgba(0,0,0,0.15)" }}
                                />
                                {color.name}
                              </span>
                            )}

                            <div>
                              <p className="text-gray-500">
                                {currency}
                                {(
                                  (product.old_price *
                                    (100 - product.new_price)) /
                                  100
                                ).toFixed(2)}{" "}
                                x {cartItems[id]}{" "}
                                <span className="line-through text-red-400 ml-2">
                                  {currency}
                                  {product.old_price.toFixed(2)}
                                </span>
                              </p>
                              <p className="text-gray-700 mt-1">
                                Total: {currency}
                                {(
                                  ((product.old_price *
                                    (100 - product.new_price)) /
                                    100) *
                                  cartItems[id]
                                ).toFixed(2)}
                              </p>
                            </div>

                            <div className="flex justify-between items-center mt-2">
                              <div className="flex gap-2 items-center">
                                {(() => {
                                  const step =
                                    product.scale?.toLowerCase() === "meters"
                                      ? 0.5
                                      : 1;
                                  const minVal = step;
                                  return (
                                    <div className="flex items-center border border-[#dae2e6] rounded-lg overflow-hidden">
                                      <button
                                        className="px-3 py-1 border-r border-[#dae2e6]"
                                        onClick={() => {
                                          if (cartItems[id] <= minVal) {
                                            setConfirmDeleteId(id);
                                          } else {
                                            removeFromCart(id, step);
                                          }
                                        }}
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        value={cartItems[id]}
                                        onChange={(e) => {
                                          const newVal =
                                            parseFloat(e.target.value) ||
                                            minVal;
                                          if (newVal >= minVal) {
                                            // addToCart adds a delta, so pass the difference to set the value
                                            const delta =
                                              newVal - (cartItems[id] || 0);
                                            if (delta !== 0) {
                                              addToCart(id, delta);
                                            }
                                          }
                                        }}
                                        className="w-16 text-center outline-none"
                                        step={step}
                                        min={minVal}
                                      />
                                      <button
                                        className="px-3 py-1 border-l border-[#dae2e6] disabled:text-gray-300 disabled:cursor-not-allowed"
                                        disabled={cartItems[id] >= parseFloat(product.quantity)}
                                        onClick={() =>
                                          addToCart(id, step)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  );
                                })()}
                              </div>

                              <button
                                className="p-1"
                                onClick={() => setConfirmDeleteId(id)}
                              >
                                <MdDelete className="text-lg text-red-500" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null;
                    })
                ) : (
                  <div className="text-center py-12 text-xl text-gray-500">
                    Your cart is empty!
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="flex justify-between items-center px-5 py-4 border-t">
                <p className="text-lg font-semibold">
                  Total: {currency}
                  {getTotalCartAmount().toFixed(2)}
                </p>

                {Object.keys(cartItems).filter((id) => cartItems[id] > 0)
                  .length > 0 && (
                  <button
                    className="text-white px-5 py-2 rounded-full font-semibold hover:opacity-90 active:scale-95 transition-all duration-200 shadow"
                    style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                    onClick={() => {
                      setOpen(false);
                      handlePopupNow(true);
                    }}
                  >
                    Checkout
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Confirm before removing a cart line — offers "move to wishlist"
            instead of losing interest in the product entirely. Triggered
            when the "-" stepper would drop below the minimum quantity, or
            the trash icon is clicked directly. */}
        {confirmDeleteId && (() => {
          const { productId, colorId } = parseCartKey(confirmDeleteId);
          const cProduct = products.find((p) => p.id === productId);
          if (!cProduct) return null;
          const cColor = findColorInProduct(cProduct, colorId);
          const cImage = cColor?.images?.[0] || cProduct.images?.[0];
          const cPrice = ((cProduct.old_price * (100 - cProduct.new_price)) / 100).toFixed(2);

          const handleRemove = () => {
            deleteFromCart(confirmDeleteId);
            setConfirmDeleteId(null);
          };

          const handleMoveToWishlist = () => {
            toggleWishlist({
              id: cProduct.id,
              name: cProduct.name,
              image: cImage,
              new_price: cPrice,
            });
            deleteFromCart(confirmDeleteId);
            setConfirmDeleteId(null);
            toast.success("Moved to your wishlist");
          };

          return (
            <div
              className="fixed inset-0 bg-black/50 z-[90] flex items-center justify-center px-4"
              onClick={() => setConfirmDeleteId(null)}
            >
              <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  crossOrigin="anonymous"
                  src={cImage}
                  alt={cProduct.name}
                  className="w-20 h-20 object-cover rounded-xl border border-gray-100 mx-auto mb-4"
                />
                <h3 className="font-bold text-gray-900 text-lg mb-1">Remove from cart?</h3>
                <p className="text-sm text-gray-500 mb-6">
                  {cProduct.name}
                  {cColor ? ` — ${cColor.name}` : ""} will be removed from your cart.
                </p>
                <button
                  onClick={handleMoveToWishlist}
                  className="w-full flex items-center justify-center gap-2 py-3 rounded-xl font-semibold text-white shadow-md mb-3 hover:opacity-90 active:scale-[0.98] transition-all"
                  style={{ background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }}
                >
                  <FaHeart size={14} /> Save to Wishlist instead
                </button>
                <button
                  onClick={handleRemove}
                  className="w-full py-3 rounded-xl font-semibold text-red-500 border-2 border-red-200 hover:bg-red-50 transition-all mb-3"
                >
                  Remove from Cart
                </button>
                <button
                  onClick={() => setConfirmDeleteId(null)}
                  className="text-sm text-gray-400 hover:text-gray-600 font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          );
        })()}

        <OrderWithCartsPopup
          cartItems={Object.keys(cartItems)
            .filter((id) => cartItems[id] > 0)
            .map((id) => {
              const { productId, colorId } = parseCartKey(id);
              const product = products.find((p) => p.id === productId);
              if (!product) return null;
              const color = findColorInProduct(product, colorId);

              const price =
                (product.old_price * (100 - product.new_price)) / 100;

              return {
                id: product.id,
                productId: product._id,
                name: product.name,
                quantity: cartItems[id],
                price: price,
                image: color?.images?.[0] || product.images?.[0] || "",
                color: color?.name || "",
                colorHex: color?.hex || "",
              };
            })
            .filter(Boolean)}
          currency={currency}
          showPopup={showPopup}
          closePopup={closePopup}
        />
      </div>
    </>
  );
};

export default Search;
